import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import RingChart from '../../../charts/echarts/RingChart'
import ChartProvider from '../../../charts/echarts/ChartProvider'
import CustomChart from '../../../charts/echarts/CustomChart'

function ScoreRing ({
  startAngle,
  endAngle,
  min,
  max,
  color,
  score,
  chartOptions,
  ringSeriesOptions,
  pointSeriesOptions
}) {
  const renderItem = useCallback((params, api) => {
    // // eslint-disable-next-line no-debugger
    // debugger
    const width = api.getWidth()
    const height = api.getHeight()
    const cx = width / 2
    const cy = height / 2
    const outerRadius = Math.min(width, height) / 2
    const arcRadius = outerRadius - 10 / 2

    // const radius = Math.min(width, height) * 0.4 // Matches gauge radius (80% of smaller dim * 0.5)

    // Calculate angle for the value
    const angleDeg = startAngle + ((score - min) / (max - min)) * (startAngle - endAngle)
    const angle = (angleDeg * Math.PI) / 180

    const x = cx + arcRadius * Math.cos(angle)
    const y = cy - arcRadius * Math.sin(angle) // Y is flipped in canvas

    return {
      type: 'circle',
      shape: {
        cx: x,
        cy: y,
        r: 8
      },
      style: {
        fill: color
      }
    }
  }, [color, endAngle, max, min, startAngle, score])

  const ringOptions = useMemo(() => {
    return {
      startAngle,
      endAngle,
      radius: '100%',
      progress: { show: false },
      axisLine: {
        show: true,
        lineStyle: {
          color: [[1, color]],
          opacity: 0.3
        }
      },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      title: { show: false },
      detail: { show: true, offsetCenter: [0, 0], color },
      anchor: { show: false },
      ...(ringSeriesOptions ?? {})
    }
  }, [color, endAngle, startAngle, ringSeriesOptions])

  const pointOptions = useMemo(() => {
    return {
      coordinateSystem: null,
      ...(pointSeriesOptions ?? {})
    }
  }, [pointSeriesOptions])

  return (
    <ChartProvider {...chartOptions}>
      <RingChart
        seriesId='ringSeries'
        data={[{ value: score }]}
        {...ringOptions}
      />
      <CustomChart
        seriesId='pointSeries'
        data={[score]}
        renderItem={renderItem}
        {...pointOptions}
      />
    </ChartProvider>
  )
}

ScoreRing.propTypes = {
  score: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  startAngle: PropTypes.number,
  endAngle: PropTypes.number,
  color: PropTypes.string,
  ringSeriesOptions: PropTypes.object,
  pointSeriesOptions: PropTypes.object,
  chartOptions: PropTypes.object
}

ScoreRing.defaultProps = {
  min: 0,
  max: 100,
  startAngle: 90,
  endAngle: -270,
  color: '#00F',
  chartOptions: {
    width: 150,
    height: 150
  },
  ringSeriesOptions: {
    height: 150,
    width: 150
  },
  pointSeriesOptions: {

  }
}

export default ScoreRing
